/**
 * Tipo de desconto disponível no sistema
 */
export enum TipoDesconto {
  /** Desconto em percentual (ex: 10% de desconto) */
  PERCENTUAL = 'PERCENTUAL',
  /** Desconto em valor fixo (ex: R$ 50,00 de desconto) */
  VALOR_FIXO = 'VALOR_FIXO',
}

/**
 * Duração do desconto
 */
export enum DuracaoDesconto {
  /** Desconto aplicado apenas uma vez */
  UNICO = 'UNICO',
  /** Desconto válido por X meses */
  MESES = 'MESES',
  /** Desconto vitalício (enquanto a assinatura estiver ativa) */
  VITALICIO = 'VITALICIO',
}

/**
 * Status do desconto aplicado a um item específico (plano ou permissão)
 */
export enum StatusDescontoAplicado {
  /** Desconto ativo e sendo aplicado */
  ATIVO = 'ATIVO',
  /** Desconto inativado manualmente */
  INATIVO = 'INATIVO',
  /** Desconto expirado por prazo ou limite de uso */
  EXPIRADO = 'EXPIRADO',
  /** Desconto cancelado (ex: usuário cancelou assinatura) */
  CANCELADO = 'CANCELADO',
}
